import "./App.css";
import { Mainroute } from "./routes/Mainroute";

function App() {
  return (
    <div className="App">
      <Mainroute />
    </div>
  );
}

export default App;
